import { AvatarTheme, styles, variants } from '../AvatarStyles.css';
import { baseTheme } from './AvatarBaseTheme.css';
import { multiVariantStyles } from './AvatarVariants.css';

/*******************
 * Component Theme
 *******************/

const AvatarRedwoodTheme: AvatarTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { AvatarRedwoodTheme };
